import { FC, KeyboardEvent, MouseEvent } from "react";
import { NavigationItem as INavigationItem } from "../../hooks/useNavigation";

interface NavigationItemProps {
  item: INavigationItem;
  isActive: boolean;
  collapsed: boolean;
  onClick: (path: string) => void;
}

export const NavigationItem: FC<NavigationItemProps> = ({
  item,
  isActive,
  collapsed,
  onClick,
}) => {
  const Icon = item.icon;

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    onClick(item.path);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(item.path);
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      title={collapsed ? item.text : undefined}
      aria-label={item.ariaLabel || `Navigate to ${item.text}`}
      className={`group flex items-center gap-3 rounded-lg cursor-pointer transition-all duration-200 text-sm
        ${collapsed ? "justify-center px-2 py-2.5 mx-2" : "px-3 py-2.5 mx-3"}
        ${
          isActive
            ? "bg-primary text-white font-medium shadow-sm"
            : "text-text-body hover:bg-bg-light hover:text-text-heading"
        }
        focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2`}
    >
      <Icon
        size={20}
        strokeWidth={isActive ? 2.2 : 1.8}
        className={`shrink-0 transition-colors ${
          isActive ? "text-white" : "text-text-muted group-hover:text-text-heading"
        }`}
      />
      {!collapsed && (
        <span className="truncate leading-tight">{item.text}</span>
      )}
    </div>
  );
};
